import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpErrorResponse } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { catchError, throwError } from 'rxjs';
import { ErrorDialogComponent } from '../../shared/dialog/error-dialog/error-dialog.component';
import { AnalyticsService } from '../services/adobe-analytics/analytics.service';
import { environment } from '../../../environments/environment';
import { Utils } from '../../shared/utils/utils';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

  constructor(private dialog: MatDialog, private analyticsService: AnalyticsService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {

        const dialogConfig = {
          width: '500px',
          panelClass: 'clientFinishDialog-panel',
          disableClose: true,
          data: {
            title: 'Vaya... ',
            subtitle: 'Ha ocurrido un error en la aplicación. Vuelve a intentarlo más tarde.',
            icon: 'sad-face',
            helpCard: false,
            buttonDisabled: true
          },
        };

        this.analyticsService.resetDataLayer();
        const sessionData = (() => {
          const stored = sessionStorage.getItem('analyticsData');
          return stored ? JSON.parse(stored) : {};
        })();

        this.analyticsService.setPhysicalUrl(environment.baseUrl + (sessionData.aliasProducto ?? ''));
        this.analyticsService.setPageName('app_cotizador:area_publica:sales:creditcardPayment:error');
        this.analyticsService.setPageContentType('cotizador');
        this.analyticsService.setPageDigitalChannel('app_cotizador');
        this.analyticsService.setPageSection('area_publica');
        this.analyticsService.setPageLanguage('es');
        this.analyticsService.setNivel1('sales');
        this.analyticsService.setNivel2('creditcardPayment');
        this.analyticsService.setProcessStep('13');
        this.analyticsService.setProcessType('sales');
        this.analyticsService.setProcessName('sales_creditcardPayment_error');
        this.analyticsService.setProcessStatus('resumen');
        this.analyticsService.setUserStatus('no_logado');
        this.analyticsService.setUserLang('es');
        const personalFormData = sessionStorage.getItem('personalForm');
        let userBirth = '';
        if (personalFormData) {
          try {
            const parsed = JSON.parse(personalFormData);
            userBirth = parsed.fechaNacimiento ?? '';
          } catch (err) {}
        }
        this.analyticsService.setUserBirth(userBirth);
        this.analyticsService.setUserResidence('VERDADERO');
        this.analyticsService.setFamilySelection('creditcardPayment');
        this.analyticsService.setCategoryActionLabel('click-button:payment:abrir_pagina_payment');
        this.analyticsService.setProductName(Utils.sanitizeString(sessionData.productName ?? ''));
        this.analyticsService.setProductType(Utils.sanitizeString(sessionData.productType ?? ''));
        this.analyticsService.setProductArea(sessionData.productArea ?? '');
        this.analyticsService.setProductDate(Utils.getProductDate());
        this.analyticsService.setProductCostStart(sessionData.productCostStart ?? '');
        this.analyticsService.setProductCostUpgrades(sessionData.productCostUpgrades ?? '');
        const quotationId = sessionStorage.getItem('quotationId') ?? '';
        this.analyticsService.setIDPresupuesto(quotationId);
        this.analyticsService.setProductPayment('Anual (' + (sessionData.productCostStart ?? '') + ' €/año)');
        this.analyticsService.setProductPaymentType('Cliente con Tarjeta');

        this.analyticsService.startEventWithCallback('imPageview', () => {
          this.dialog.open(ErrorDialogComponent, dialogConfig);
        });

        return throwError(() => error);
      })
    );
  }
}
